import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ProgressBar from 'react-bootstrap/ProgressBar';

function Confirmation() {
    const location = useLocation();
    const { data } = location.state || {};
    const [randomDeliveryTime, setRandomDeliveryTime] = useState();
    const [startTime, setProgressTracker] = useState();

    useEffect(() => {
        const minMinutes = 1;
        const maxMinutes = 20;
        const deliveryTime = Math.floor(Math.random() * (maxMinutes - minMinutes + 1)) + minMinutes;
        setRandomDeliveryTime(deliveryTime * 60);
        setProgressTracker(deliveryTime * 60);
    }, []);

    useEffect(() => {
        const timer = randomDeliveryTime > 0 && setInterval(() => setRandomDeliveryTime(randomDeliveryTime - 1), 1000);
        return () => clearInterval(timer);
    }, [randomDeliveryTime]);

    const calcProgressbar = () => {
        let progressTracker = ((startTime - randomDeliveryTime) / startTime) * 100;
        if (progressTracker < 20) {
            progressTracker = 20;
        }
        return progressTracker;
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            textAlign: 'center',
            padding: '20px',
        }}>
            <h1>Tack för din order {data?.customerDetails?.customerName}!</h1>
            <h3>Order {data?.orderId}</h3>
            <div style={{ marginTop: '30px' }}>
                <h5>Din leverans kommer fram om {(randomDeliveryTime / 60).toFixed(0)} minuter</h5>
                <ProgressBar animated now={calcProgressbar()} />
            </div>

            <div style={{
                width: '80%',
                marginTop: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                {data?.articles?.map((product) => (
                    <div
                        key={product.id}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            marginBottom: '15px',
                            padding: '15px',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            width: '100%',
                            maxWidth: '600px', 
                        }}
                    >
                        <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>{product.title}</p>
                        <p style={{ marginBottom: '5px' }}>Kvantitet: {product.quantity}</p>
                        <p style={{ marginBottom: '5px' }}>Totalt: {product.price * product.quantity} kr</p>
                    </div>
                ))}
            </div>


        </div>
    );
}

export default Confirmation;
